/* script */
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

	import * as global from "../../../js/global";
	import * as helper from "../../../js/helper";
	import full_loading from "../../components/full-loading.vue";
	import mashro_component from "../../components/mashro-component.vue";
	import search_mashro_filters_modal from "../../modal/search-mashro-filters-modal.vue";
	import filter_tablets_component from "../../components/filter-tablets-component.vue";
	import transfer_mashro_modal from "../../modal/transfer-mashro-modal.vue";
	const __vue_script__ ={
        components: {
            full_loading:full_loading,
            mashro_component:mashro_component,
            search_mashro_filters_modal:search_mashro_filters_modal,
            filter_tablets_component:filter_tablets_component,
            transfer_mashro_modal:transfer_mashro_modal
        },
		name:'mashro_list_widget',
        props: {
            has_mashros: {
                type: String,
                default: true
            },
            developer_id: {
                type: String,
                default: null
            },
        },
		data() {
			return {
                global,
                helper,
                frappe,
                search_filters:localStorage.mashro_list_search_filters?JSON.parse(localStorage.mashro_list_search_filters):global.search_projects_filters,
                is_ready:false,
                is_loading:false,
				mashros: [],
                page: 0,
			}
		},
        mounted(){
            this.has_mashros = this.has_mashros == 1
            global.emitter.on("load-search-again", args => {
                this.load_data(true);
            });
            if(!helper.isPageNew()){
                this.check_local_storage();
            }else{
                this.load_data(true);
            }
            // window.addEventListener("scroll",this.handleScroll);
        },
        unmounted(){
            // window.removeEventListener("scroll",this.handleScroll);
        },
		methods: {
            check_local_storage: async function(){
                this.page = await localStorage.my_catalogue_page?localStorage.my_catalogue_page:0;
                this.end_of_page = localStorage.my_catalogue_end_of_page == 1?true:false;
                this.mashros = localStorage.my_catalogue_records?JSON.parse(localStorage.my_catalogue_records):[];
                this.$forceUpdate(); 
            },
            load_data: async function(reload=false){
                if(this.is_loading)
                    return;
                if(reload){
                    this.page = 0;
                    this.end_of_page = false;
                    while(this.mashros.length > 0) {
                        this.mashros.pop();
                    }
                }
                if(this.end_of_page)
                    return;
                global.emitter.emit("show-full-loading");
                this.is_loading = true;
                if(this.search_filters.region){
                    this.search_filters.region.bounds = null;
                }
                let params = {
                    "filters":JSON.stringify(this.search_filters),
                    "page":this.page
                };
                console.log("params");
                console.log(params);
                if(this.developer_id){
                    params["developer_id"] = this.developer_id;
                }
                let url = "/api/method/maalek.api.my_list_mashros";
                let res = await $.ajax({
                    url: url,
                    type: "GET",
                    data: params
                });
                if(res.message.length > 0){
                    for (let index = 0; index < res.message.length; index++) {
                        this.mashros.push(res.message[index]);
                    }
                    this.page++;
                }else{
                    this.end_of_page = 1;
                }
                localStorage.my_catalogue_records = JSON.stringify(this.properties);
                localStorage.mashro_list_search_filters = JSON.stringify(this.search_filters);
                localStorage.my_catalogue_page = this.page;
                localStorage.my_catalogue_end_of_page = this.end_of_page?1:0;
                this.is_loading = false;
                this.is_ready = true;
                global.emitter.emit("hide-full-loading");
            },
            handleScroll: function (){
                if(this.end_of_page){
                    window.removeEventListener("scroll",this.handleScroll);
                }
                if(this.loading || this.end_of_page)
                    return;
                let pagination_component = this.$refs["pagination_component"];
                if (pagination_component.getBoundingClientRect().bottom < window.innerHeight) {
                    this.load_data();
                }
            }
		},
		computed:{
		}
	}

/* template */
var __vue_render__ = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "my-listing" },
    [
      _c("full_loading"),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "d-flex justify-content-end mb-4" },
        [
          false
            ? _c("filter_tablets_component", {
                attrs: { search_filters_prop: _vm.search_filters }
              })
            : _vm._e(),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "btn-toolbar",
              attrs: {
                role: "toolbar",
                "aria-label": "Toolbar with button groups"
              }
            },
            [
              _c(
                "div",
                {
                  staticClass: "btn-group",
                  attrs: { role: "group", "aria-label": "Third group" }
                },
                [
                  _c(
                    "button",
                    {
                      staticClass: "btn btn-outline-secondary",
                      attrs: {
                        type: "button",
                        "data-bs-toggle": "modal",
                        "data-bs-target": "#searchProjectsFiltersModal"
                      }
                    },
                    [
                      _c("i", { staticClass: "fa-solid fa-sliders" }),
                      _vm._v(
                        " " +
                          _vm._s(_vm.helper.t("More Filters")) +
                          "\n                "
                      )
                    ]
                  )
                ]
              )
            ]
          )
        ],
        1
      ),
      _vm._v(" "),
      (_vm.frappe.user_roles.includes("Developer") ||
        _vm.frappe.user_roles.includes("Mashro Manager")) &&
      !_vm.has_mashros
        ? _c("div", { staticClass: "text-center mt-5" }, [
            _c(
              "a",
              {
                staticClass: "btn default-btn ms-auto h-25 py-4",
                attrs: { href: "/account/add-project", target: "_blank" }
              },
              [
                _c("span", { staticClass: "ri-add-circle-line fa-lg" }),
                _vm._v(" " + _vm._s(_vm.helper.t("Add Project")) + "\n        ")
              ]
            )
          ])
        : _vm._e(),
      _vm._v(" "),
      _c(
        "div",
        { ref: "pagination_component", staticClass: "row" },
        [
          _vm._l(_vm.mashros, function(mashro) {
            return _c(
              "div",
              { staticClass: "col-xl-3 col-lg-4" },
              [_c("mashro_component", { attrs: { mashro: mashro } })],
              1
            )
          }),
          _vm._v(" "),
          !_vm.is_loading && _vm.is_ready && _vm.mashros.length == 0
            ? _c("p", { staticClass: "text-center mt-5" }, [
                _vm._v(_vm._s(_vm.helper.t("No projects to show!")))
              ])
            : _vm._e()
        ],
        2
      ),
      _vm._v(" "),
      _c("search_mashro_filters_modal", {
        attrs: { search_filters_prop: _vm.search_filters }
      }),
      _vm._v(" "),
      _c("transfer_mashro_modal")
    ],
    1
  )
}
var __vue_staticRenderFns__ = []
__vue_render__._withStripped = true

  /* style */
  const __vue_inject_styles__ = function (inject) {
    if (!inject) return
    inject("data-v-f9da811a_0", { source: "\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n", map: {"version":3,"sources":[],"names":[],"mappings":"","file":"my-mashro-list-widget.vue"}, media: undefined })

  }
  /* scoped */
  const __vue_scope_id__ = undefined
  /* module identifier */
  const __vue_module_identifier__ = undefined
  /* functional template */
  const __vue_is_functional_template__ = false
  /* component normalizer */
  function __vue_normalize__(
    template, style, script,
    scope, functional, moduleIdentifier, shadowMode,
    createInjector, createInjectorSSR, createInjectorShadow
  ) {
    const component = (typeof script === 'function' ? script.options : script) || {}

    // For security concerns, we use only base name in production mode.
    component.__file = "../maalek/maalek/public/vue/widgets/account/my-mashro-list-widget.vue"

    if (!component.render) {
      component.render = template.render
      component.staticRenderFns = template.staticRenderFns
      component._compiled = true

      if (functional) component.functional = true
    }

    component._scopeId = scope

    if (true) {
      let hook
      if (false) {
        // In SSR.
        hook = function(context) {
          // 2.3 injection
          context =
            context || // cached call
            (this.$vnode && this.$vnode.ssrContext) || // stateful
            (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
          // 2.2 with runInNewContext: true
          if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
            context = __VUE_SSR_CONTEXT__
          }
          // inject component styles
          if (style) {
            style.call(this, createInjectorSSR(context))
          }
          // register component module identifier for async chunk inference
          if (context && context._registeredComponents) {
            context._registeredComponents.add(moduleIdentifier)
          }
        }
        // used by ssr in case component is cached and beforeCreate
        // never gets called
        component._ssrRegister = hook
      }
      else if (style) {
        hook = shadowMode 
          ? function(context) {
              style.call(this, createInjectorShadow(context, this.$root.$options.shadowRoot))
            }
          : function(context) {
              style.call(this, createInjector(context))
            }
      }

      if (hook !== undefined) {
        if (component.functional) {
          // register for functional component in vue file
          const originalRender = component.render
          component.render = function renderWithStyleInjection(h, context) {
            hook.call(context)
            return originalRender(h, context)
          }
        } else {
          // inject component registration as beforeCreate hook
          const existing = component.beforeCreate
          component.beforeCreate = existing ? [].concat(existing, hook) : [hook]
        }
      }
    }

    return component
  }
  /* style inject */
  function __vue_create_injector__() {
    const styles = __vue_create_injector__.styles || (__vue_create_injector__.styles = {})
    const isOldIE =
      typeof navigator !== 'undefined' &&
      /msie [6-9]\\b/.test(navigator.userAgent.toLowerCase())

    return function addStyle(id, css) {
      if (document.querySelector('style[data-vue-ssr-id~="' + id + '"]')) return // SSR styles are present.

      const group = isOldIE ? css.media || 'default' : id
      const style = styles[group] || (styles[group] = { ids: [], parts: [], element: undefined })

      if (!style.ids.includes(id)) {
        let code = css.source
        let index = style.ids.length

        style.ids.push(id)

        if (false && css.map) {
          // https://developer.chrome.com/devtools/docs/javascript-debugging
          // this makes source maps inside style tags work properly in Chrome
          code += '\n/*# sourceURL=' + css.map.sources[0] + ' */'
          // http://stackoverflow.com/a/26603875
          code +=
            '\n/*# sourceMappingURL=data:application/json;base64,' +
            btoa(unescape(encodeURIComponent(JSON.stringify(css.map)))) +
            ' */'
        }

        if (isOldIE) {
          style.element = style.element || document.querySelector('style[data-group=' + group + ']')
        }

        if (!style.element) {
          const head = document.head || document.getElementsByTagName('head')[0]
          const el = style.element = document.createElement('style')
          el.type = 'text/css'

          if (css.media) el.setAttribute('media', css.media)
          if (isOldIE) {
            el.setAttribute('data-group', group)
            el.setAttribute('data-next-index', '0')
          }

          head.appendChild(el)
        }

        if (isOldIE) {
          index = parseInt(style.element.getAttribute('data-next-index'))
          style.element.setAttribute('data-next-index', index + 1)
        }

        if (style.element.styleSheet) {
          style.parts.push(code)
          style.element.styleSheet.cssText = style.parts
            .filter(Boolean)
            .join('\n')
        } else {
          const textNode = document.createTextNode(code)
          const nodes = style.element.childNodes
          if (nodes[index]) style.element.removeChild(nodes[index])
          if (nodes.length) style.element.insertBefore(textNode, nodes[index])
          else style.element.appendChild(textNode)
        }
      }
    }
  }
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/__vue_normalize__(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    __vue_create_injector__,
    undefined,
    undefined
  )

  export default __vue_component__